var render = function () {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: !_vm.overviewAccessReady && !_vm.overviewAccessError,
          expression: "!overviewAccessReady && !overviewAccessError",
        },
      ],
      staticClass: "data-overview",
    },
    [
      _vm.overviewAccessError
        ? _c("el-alert", {
            attrs: {
              title: _vm.overviewAccessError,
              type: "error",
              closable: false,
              "show-icon": "",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "page-head" },
        [
          _c(
            "el-tabs",
            {
              staticClass: "head-tabs",
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _vm.checkPermi([
                "admin:core:overview:user:data",
                "admin:core:overview:transaction:data",
                "admin:core:overview:cart:product:top",
                "admin:core:overview:hourly:pay:trend",
              ])
                ? _c("el-tab-pane", {
                    attrs: { label: "核心总览看板", name: "core" },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.checkPermi([
                "admin:core:overview:traffic:data",
                "admin:core:overview:hourly:traffic:trend",
                "admin:core:overview:duration:distribution",
              ])
                ? _c("el-tab-pane", {
                    attrs: { label: "分区看板", name: "zone" },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "head-filter" },
            [
              _c("span", { staticClass: "filter-label" }, [_vm._v("小程序:")]),
              _vm._v(" "),
              _vm.overviewAccessReady && !_vm.isCustomerAccount
                ? _c(
                    "el-select",
                    {
                      ref: "miniAppSelect",
                      staticStyle: { width: "220px" },
                      attrs: {
                        size: "small",
                        multiple: "",
                        "collapse-tags": "",
                        clearable: "",
                        filterable: "",
                        placeholder: "全部小程序",
                      },
                      on: {
                        clear: function ($event) {
                          return _vm.resetSelectQuery("miniAppSelect")
                        },
                        "remove-tag": function ($event) {
                          return _vm.resetSelectQuery("miniAppSelect")
                        },
                        "visible-change": function (visible) {
                          if (!visible) {
                            this$1.resetSelectQuery("miniAppSelect")
                          }
                        },
                      },
                      model: {
                        value: _vm.miniAppIds,
                        callback: function ($$v) {
                          _vm.miniAppIds = $$v
                        },
                        expression: "miniAppIds",
                      },
                    },
                    _vm._l(_vm.miniAppOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  )
                : _vm.overviewAccessReady && _vm.isCustomerAccount
                ? _c("span", [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.overviewAccess.customerName ||
                            "小程序 " + _vm.overviewAccess.customerId
                        ) +
                        "\n      "
                    ),
                  ])
                : _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.overviewAccessError
                          ? "无可用数据范围"
                          : "权限加载中"
                      )
                    ),
                  ]),
              _vm._v(" "),
              _vm.activeTab === "zone"
                ? [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "has-permi",
                            rawName: "v-has-permi",
                            value: ["admin:core:overview:design:auth:page"],
                            expression:
                              "['admin:core:overview:design:auth:page']",
                          },
                        ],
                        staticClass: "filter-label",
                      },
                      [_vm._v("装修页:")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-select",
                      {
                        directives: [
                          {
                            name: "has-permi",
                            rawName: "v-has-permi",
                            value: ["admin:core:overview:design:auth:page"],
                            expression:
                              "['admin:core:overview:design:auth:page']",
                          },
                        ],
                        ref: "decorationPageSelect",
                        staticStyle: { width: "200px" },
                        attrs: {
                          size: "small",
                          clearable: "",
                          filterable: "",
                          remote: "",
                          "remote-method": _vm.searchDecorationPages,
                          loading: _vm.decorationPageLoading,
                          placeholder: "全部装修页",
                        },
                        on: {
                          focus: _vm.ensureDecorationPages,
                          clear: _vm.handleDecorationClear,
                          "visible-change": _vm.handleDecorationVisibleChange,
                        },
                        model: {
                          value: _vm.decorationPageId,
                          callback: function ($$v) {
                            _vm.decorationPageId = $$v
                          },
                          expression: "decorationPageId",
                        },
                      },
                      [
                        _vm._l(_vm.decorationPageOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        _vm._v(" "),
                        _vm.decorationPageLoadingMore
                          ? _c("el-option", {
                              attrs: {
                                disabled: "",
                                value: "__deco_loading",
                                label: "加载中...",
                              },
                            })
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.overviewAccessReady
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeTab === "core",
                  expression: "activeTab === 'core'",
                },
              ],
              staticClass: "page-body",
            },
            [
              _c(
                "section",
                {
                  directives: [
                    {
                      name: "has-permi",
                      rawName: "v-has-permi",
                      value: ["admin:core:overview:user:data"],
                      expression: "['admin:core:overview:user:data']",
                    },
                  ],
                  staticClass: "panel",
                },
                [
                  _c("div", { staticClass: "panel-toolbar" }, [
                    _c("div", { staticClass: "panel-title" }, [
                      _vm._v("用户数据"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "toolbar-right" },
                      [
                        !_vm.userLoading
                          ? _c("span", { staticClass: "data-time" }, [
                              _vm._v(
                                "数据时间 " + _vm._s(_vm.userMetrics.dataTime)
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "120px" },
                            attrs: { size: "small" },
                            model: {
                              value: _vm.userDateRange,
                              callback: function ($$v) {
                                _vm.userDateRange = $$v
                              },
                              expression: "userDateRange",
                            },
                          },
                          _vm._l(_vm.dateRangeOptions, function (item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.value },
                            })
                          }),
                          1
                        ),
                        _vm._v(" "),
                        _vm.userDateRange === 5
                          ? _c("el-date-picker", {
                              staticStyle: { width: "360px" },
                              attrs: {
                                type: "datetimerange",
                                size: "small",
                                "value-format": "yyyy-MM-dd HH:mm:ss",
                                format: "yyyy-MM-dd HH:mm:ss",
                                "default-time": ["00:00:00", "23:59:59"],
                                "range-separator": "至",
                                "start-placeholder": "开始时间",
                                "end-placeholder": "结束时间",
                              },
                              model: {
                                value: _vm.userCustomRange,
                                callback: function ($$v) {
                                  _vm.userCustomRange = $$v
                                },
                                expression: "userCustomRange",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "btn-apply",
                            attrs: { type: "success", size: "small" },
                            on: { click: _vm.applyUserFilter },
                          },
                          [_vm._v("应用筛选")]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.userLoading,
                          expression: "userLoading",
                        },
                      ],
                      staticClass: "metric-row cols-3",
                    },
                    _vm._l(_vm.userMetrics.list, function (item, itemIdx) {
                      return _c(
                        "div",
                        { key: item.key, staticClass: "metric-item" },
                        [
                          _c(
                            "div",
                            { staticClass: "metric-label" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(item.label) +
                                  "\n            "
                              ),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: item.tip,
                                    placement: "top",
                                    "popper-class": "overview-metric-tip",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-info metric-tip",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "metric-value" }, [
                            _c("span", { staticClass: "num" }, [
                              _vm._v(_vm._s(item.value)),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "unit" }, [
                              _vm._v(_vm._s(item.unit)),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "metric-compares" },
                            _vm._l(item.compareList, function (c, idx) {
                              return _c(
                                "div",
                                {
                                  key: idx,
                                  staticClass: "metric-compare",
                                  class: _vm.compareClass(c.rate),
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "compare-text" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(c.text) +
                                          "\n                "
                                      ),
                                      itemIdx === 0
                                        ? _c(
                                            "el-tooltip",
                                            {
                                              attrs: {
                                                content: c.tip,
                                                placement: "top",
                                                "popper-class":
                                                  "overview-metric-tip",
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-info metric-tip",
                                              }),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.formatRate(c.rate)) +
                                      "\n            "
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "section",
                {
                  directives: [
                    {
                      name: "has-permi",
                      rawName: "v-has-permi",
                      value: ["admin:core:overview:transaction:data"],
                      expression: "['admin:core:overview:transaction:data']",
                    },
                  ],
                  staticClass: "panel",
                },
                [
                  _c("div", { staticClass: "panel-toolbar" }, [
                    _c("div", { staticClass: "panel-title" }, [
                      _vm._v("交易指标概况"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "toolbar-right" },
                      [
                        _c("span", { staticClass: "filter-label" }, [
                          _vm._v("订单类型"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "140px" },
                            attrs: {
                              size: "small",
                              clearable: "",
                              placeholder: "全部",
                            },
                            model: {
                              value: _vm.orderType,
                              callback: function ($$v) {
                                _vm.orderType = $$v
                              },
                              expression: "orderType",
                            },
                          },
                          _vm._l(_vm.orderTypeOptions, function (item) {
                            return _c("el-option", {
                              key: item.key,
                              attrs: { label: item.value, value: item.key },
                            })
                          }),
                          1
                        ),
                        _vm._v(" "),
                        !_vm.tradeLoading
                          ? _c("span", { staticClass: "data-time" }, [
                              _vm._v(
                                "数据时间 " + _vm._s(_vm.tradeMetrics.dataTime)
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "120px" },
                            attrs: { size: "small" },
                            model: {
                              value: _vm.tradeDateRange,
                              callback: function ($$v) {
                                _vm.tradeDateRange = $$v
                              },
                              expression: "tradeDateRange",
                            },
                          },
                          _vm._l(_vm.dateRangeOptions, function (item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.value },
                            })
                          }),
                          1
                        ),
                        _vm._v(" "),
                        _vm.tradeDateRange === 5
                          ? _c("el-date-picker", {
                              staticStyle: { width: "360px" },
                              attrs: {
                                type: "datetimerange",
                                size: "small",
                                "value-format": "yyyy-MM-dd HH:mm:ss",
                                format: "yyyy-MM-dd HH:mm:ss",
                                "default-time": ["00:00:00", "23:59:59"],
                                "range-separator": "至",
                                "start-placeholder": "开始时间",
                                "end-placeholder": "结束时间",
                              },
                              model: {
                                value: _vm.tradeCustomRange,
                                callback: function ($$v) {
                                  _vm.tradeCustomRange = $$v
                                },
                                expression: "tradeCustomRange",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "btn-apply",
                            attrs: { type: "success", size: "small" },
                            on: { click: _vm.applyTradeFilter },
                          },
                          [_vm._v("应用筛选")]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.tradeLoading,
                          expression: "tradeLoading",
                        },
                      ],
                      staticClass: "metric-row cols-5",
                    },
                    _vm._l(_vm.visibleTradeMetrics, function (item, itemIdx) {
                      return _c(
                        "div",
                        { key: item.key, staticClass: "metric-item" },
                        [
                          _c(
                            "div",
                            { staticClass: "metric-label" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(item.label) +
                                  "\n            "
                              ),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: item.tip,
                                    placement: "top",
                                    "popper-class": "overview-metric-tip",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-info metric-tip",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "metric-value" }, [
                            _c("span", { staticClass: "num" }, [
                              _vm._v(_vm._s(item.value)),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "unit" }, [
                              _vm._v(_vm._s(item.unit)),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "metric-compares" },
                            _vm._l(item.compareList, function (c, idx) {
                              return _c(
                                "div",
                                {
                                  key: idx,
                                  staticClass: "metric-compare",
                                  class: _vm.compareClass(c.rate),
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "compare-text" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(c.text) +
                                          "\n                "
                                      ),
                                      itemIdx === 0
                                        ? _c(
                                            "el-tooltip",
                                            {
                                              attrs: {
                                                content: c.tip,
                                                placement: "top",
                                                "popper-class":
                                                  "overview-metric-tip",
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-info metric-tip",
                                              }),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.formatRate(c.rate)) +
                                      "\n            "
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "bottom-charts single-chart" }, [
                _c(
                  "section",
                  {
                    directives: [
                      {
                        name: "has-permi",
                        rawName: "v-has-permi",
                        value: ["admin:core:overview:cart:product:top"],
                        expression: "['admin:core:overview:cart:product:top']",
                      },
                    ],
                    staticClass: "panel chart-panel",
                  },
                  [
                    _c("div", { staticClass: "panel-toolbar" }, [
                      _c(
                        "div",
                        { staticClass: "panel-title" },
                        [
                          _c("i", {
                            staticClass: "el-icon-shopping-cart-2 cart-icon",
                          }),
                          _vm._v(
                            "\n            加购未下单商品 Top5\n            "
                          ),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: _vm.chartTips.cartUnpaid,
                                placement: "top",
                                "popper-class": "overview-metric-tip",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-info metric-tip",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "toolbar-right" }, [
                        !_vm.cartLoading
                          ? _c("span", { staticClass: "data-time" }, [
                              _vm._v(
                                "数据时间 " + _vm._s(_vm.cartTop5.dataTime)
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.cartLoading,
                            expression: "cartLoading",
                          },
                        ],
                        staticClass: "chart-loading",
                      },
                      [
                        _c("echarts-new", {
                          attrs: {
                            "option-data": _vm.cartOption,
                            styles: { width: "100%", height: "360px" },
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "section",
                {
                  directives: [
                    {
                      name: "has-permi",
                      rawName: "v-has-permi",
                      value: ["admin:core:overview:hourly:pay:trend"],
                      expression: "['admin:core:overview:hourly:pay:trend']",
                    },
                  ],
                  staticClass: "panel realtime-panel",
                },
                [
                  _c("div", { staticClass: "panel-toolbar" }, [
                    _c(
                      "div",
                      { staticClass: "panel-title" },
                      [
                        _c("span", { staticClass: "title-icon bars" }),
                        _vm._v(" "),
                        _c("span", [_vm._v("实时访问用户")]),
                        _vm._v(" "),
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: _vm.chartTips.visitUsersHourly,
                              placement: "top",
                              "popper-class": "overview-metric-tip",
                            },
                          },
                          [_c("i", { staticClass: "el-icon-info metric-tip" })]
                        ),
                        _vm._v(" "),
                        _c("span", [_vm._v(" / 支付订单数")]),
                        _vm._v(" "),
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: _vm.chartTips.payOrdersHourly,
                              placement: "top",
                              "popper-class": "overview-metric-tip",
                            },
                          },
                          [_c("i", { staticClass: "el-icon-info metric-tip" })]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "toolbar-right" },
                      [
                        _c("span", { staticClass: "filter-label" }, [
                          _vm._v("日期"),
                        ]),
                        _vm._v(" "),
                        _c("el-date-picker", {
                          staticStyle: { width: "150px" },
                          attrs: {
                            type: "date",
                            size: "small",
                            "value-format": "yyyy-MM-dd",
                            format: "yyyy/MM/dd",
                            placeholder: "选择日期",
                          },
                          model: {
                            value: _vm.realtimeDate,
                            callback: function ($$v) {
                              _vm.realtimeDate = $$v
                            },
                            expression: "realtimeDate",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "btn-apply",
                            attrs: { type: "success", size: "small" },
                            on: { click: _vm.applyRealtime },
                          },
                          [_vm._v("应用")]
                        ),
                        _vm._v(" "),
                        !_vm.realtimeLoading
                          ? _c("span", { staticClass: "data-time" }, [
                              _vm._v(
                                "数据更新于：" + _vm._s(_vm.realtime.updateTime)
                              ),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "chart-caption" }, [
                    _vm._v("每小时趋势 (00:00 - 24:00)"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.realtimeLoading,
                          expression: "realtimeLoading",
                        },
                      ],
                      staticClass: "chart-loading",
                    },
                    [
                      _c("echarts-new", {
                        attrs: {
                          "option-data": _vm.realtimeOption,
                          styles: { width: "100%", height: "360px" },
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.overviewAccessReady
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeTab === "zone",
                  expression: "activeTab === 'zone'",
                },
              ],
              staticClass: "page-body",
            },
            [
              _c(
                "section",
                {
                  directives: [
                    {
                      name: "has-permi",
                      rawName: "v-has-permi",
                      value: ["admin:core:overview:traffic:data"],
                      expression: "['admin:core:overview:traffic:data']",
                    },
                  ],
                  staticClass: "panel",
                },
                [
                  _c("div", { staticClass: "panel-toolbar" }, [
                    _c("div", { staticClass: "panel-title" }, [
                      _vm._v("流量指标概况"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "toolbar-right" },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "120px" },
                            attrs: { size: "small" },
                            model: {
                              value: _vm.zoneDateRange,
                              callback: function ($$v) {
                                _vm.zoneDateRange = $$v
                              },
                              expression: "zoneDateRange",
                            },
                          },
                          _vm._l(_vm.zoneDateRangeOptions, function (item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.value },
                            })
                          }),
                          1
                        ),
                        _vm._v(" "),
                        _vm.zoneDateRange === 5
                          ? _c("el-date-picker", {
                              staticStyle: { width: "360px" },
                              attrs: {
                                type: "datetimerange",
                                size: "small",
                                "value-format": "yyyy-MM-dd HH:mm:ss",
                                format: "yyyy-MM-dd HH:mm:ss",
                                "default-time": ["00:00:00", "23:59:59"],
                                "range-separator": "至",
                                "start-placeholder": "开始时间",
                                "end-placeholder": "结束时间",
                              },
                              model: {
                                value: _vm.zoneCustomRange,
                                callback: function ($$v) {
                                  _vm.zoneCustomRange = $$v
                                },
                                expression: "zoneCustomRange",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "btn-apply",
                            attrs: { type: "success", size: "small" },
                            on: { click: _vm.applyZoneUserFilter },
                          },
                          [_vm._v("应用筛选")]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.zoneUserLoading,
                          expression: "zoneUserLoading",
                        },
                      ],
                      staticClass: "metric-row cols-3",
                    },
                    _vm._l(_vm.zoneUserMetrics.list, function (item, itemIdx) {
                      return _c(
                        "div",
                        { key: item.key, staticClass: "metric-item" },
                        [
                          _c(
                            "div",
                            { staticClass: "metric-label" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(item.label) +
                                  "\n            "
                              ),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: item.tip,
                                    placement: "top",
                                    "popper-class": "overview-metric-tip",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-info metric-tip",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "metric-value" }, [
                            _c("span", { staticClass: "num" }, [
                              _vm._v(_vm._s(item.value)),
                            ]),
                            _vm._v(" "),
                            item.unit
                              ? _c("span", { staticClass: "unit" }, [
                                  _vm._v(_vm._s(item.unit)),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "metric-compares" },
                            _vm._l(item.compareList, function (c, idx) {
                              return _c(
                                "div",
                                {
                                  key: idx,
                                  staticClass: "metric-compare",
                                  class: _vm.compareClass(c.rate),
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "compare-text" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(c.text) +
                                          "\n                "
                                      ),
                                      itemIdx === 0
                                        ? _c(
                                            "el-tooltip",
                                            {
                                              attrs: {
                                                content: c.tip,
                                                placement: "top",
                                                "popper-class":
                                                  "overview-metric-tip",
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-info metric-tip",
                                              }),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.formatRate(c.rate)) +
                                      "\n            "
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "bottom-charts zone-charts" }, [
                _c(
                  "section",
                  {
                    directives: [
                      {
                        name: "has-permi",
                        rawName: "v-has-permi",
                        value: ["admin:core:overview:hourly:traffic:trend"],
                        expression:
                          "['admin:core:overview:hourly:traffic:trend']",
                      },
                    ],
                    staticClass: "panel chart-panel",
                  },
                  [
                    _c("div", { staticClass: "panel-toolbar" }, [
                      _c(
                        "div",
                        { staticClass: "panel-title" },
                        [
                          _c("span", { staticClass: "title-icon bars" }),
                          _vm._v(" "),
                          _c("span", [_vm._v("PV")]),
                          _vm._v(" "),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: _vm.chartTips.pv,
                                placement: "top",
                                "popper-class": "overview-metric-tip",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-info metric-tip",
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", [_vm._v(" · 点击量")]),
                          _vm._v(" "),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: _vm.chartTips.clicks,
                                placement: "top",
                                "popper-class": "overview-metric-tip",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-info metric-tip",
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", [_vm._v(" 趋势")]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "toolbar-right" },
                        [
                          _c("span", { staticClass: "filter-label" }, [
                            _vm._v("日期"),
                          ]),
                          _vm._v(" "),
                          _c("el-date-picker", {
                            staticStyle: { width: "150px" },
                            attrs: {
                              type: "date",
                              size: "small",
                              "value-format": "yyyy-MM-dd",
                              format: "yyyy/MM/dd",
                              placeholder: "选择日期",
                            },
                            model: {
                              value: _vm.zoneTrendDate,
                              callback: function ($$v) {
                                _vm.zoneTrendDate = $$v
                              },
                              expression: "zoneTrendDate",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticClass: "btn-apply",
                              attrs: { type: "success", size: "small" },
                              on: { click: _vm.applyZoneTrend },
                            },
                            [_vm._v("应用筛选")]
                          ),
                          _vm._v(" "),
                          !_vm.zonePvLoading
                            ? _c("span", { staticClass: "data-time" }, [
                                _vm._v(
                                  "数据更新于: " +
                                    _vm._s(_vm.zonePvTrend.updateTime)
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "chart-caption" }, [
                      _vm._v("每小时趋势 (00:00 - 24:00)"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.zonePvLoading,
                            expression: "zonePvLoading",
                          },
                        ],
                        staticClass: "chart-wrap chart-loading",
                      },
                      [
                        _c("echarts-new", {
                          key: "zone-pv-" + _vm.zonePvChartTick,
                          attrs: {
                            "option-data": _vm.zonePvOption,
                            styles: { width: "100%", height: "340px" },
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "section",
                  {
                    directives: [
                      {
                        name: "has-permi",
                        rawName: "v-has-permi",
                        value: ["admin:core:overview:duration:distribution"],
                        expression:
                          "['admin:core:overview:duration:distribution']",
                      },
                    ],
                    staticClass: "panel chart-panel",
                  },
                  [
                    _c("div", { staticClass: "panel-toolbar" }, [
                      _c(
                        "div",
                        { staticClass: "panel-title" },
                        [
                          _c("i", { staticClass: "el-icon-timer stay-icon" }),
                          _vm._v("\n            各停留时长分布\n            "),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: _vm.chartTips.stayDuration,
                                placement: "top",
                                "popper-class": "overview-metric-tip",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-info metric-tip",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "toolbar-right" }, [
                        !_vm.zoneStayLoading
                          ? _c("span", { staticClass: "data-time" }, [
                              _vm._v(
                                "数据更新于: " + _vm._s(_vm.zoneStay.updateTime)
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.zoneStayLoading,
                            expression: "zoneStayLoading",
                          },
                        ],
                        staticClass: "chart-wrap chart-loading",
                      },
                      [
                        _c("echarts-new", {
                          attrs: {
                            "option-data": _vm.zoneStayOption,
                            styles: { width: "100%", height: "360px" },
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }